module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/IPp2MX/tc-custom/9780253018212.jpg?1702812389567",
      "alt": "This image is the cover for the book This Is Only a Test, Break Away Book Club Edition"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("This Is Only a Test, Break Away Book Club Edition\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The Truman Capote Prize-winning author “provides an offbeat look at the fragility of human life and our resilience when faced with death” ("), _c('i', [_vm._v("Kirkus")]), _vm._v(").")]), _c('br'), _c('br'), _vm._v(" On April 27, 2011, just days after learning of their pregnancy, B. J. Hollars, his wife, and their future son endured the onslaught of an EF-4 tornado. There, while huddled in a bathtub in their Alabama home, mortality flashed before their eyes. With the last of his computer battery, Hollars began recounting the experience, and would continue to do so in the following years, writing his way out of one disaster only to find himself caught up in another."), _c('br'), _c('br'), _vm._v(" In this collection of personal essays, Hollars faces tornadoes, drownings, and nuclear catastrophes. These experiences force him to acknowledge the inexplicable while he attempts to overcome his greatest fear—the impossibility of protecting his newborn son from the world’s cruelties. Through his and others’ stories, Hollars creates a constellation of grief, tapping into the rarely acknowledged intersection between fatherhood and fear, sacrifice and safety, and the humbling effect of losing control of our lives.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      B. J. Hollars\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Indiana University Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0